import { render, staticRenderFns } from "./msgChannelMng.vue?vue&type=template&id=57982a8b"
import script from "./msgChannelMng.vue?vue&type=script&lang=js"
export * from "./msgChannelMng.vue?vue&type=script&lang=js"
import style0 from "./msgChannelMng.vue?vue&type=style&index=0&id=57982a8b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports